<div class="add-project-wizard">
    <header>
        <div class="header_main_sec">
            <div class="container">
                <div class="head_logo">
                    <a href=""><h2><img src="assets/images/logo_head.png"></h2></a>
                </div>
                <div class="page_menu"> 
                    <div class="full_screen_menu">

                        <div class="header_btn_sect"> 

                            <div class="user"> 
                                <a routerLink="/dashboard" class="add_btn btn" href=""><i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;Dashboard</a>
                                <a href="" class="lg-user"><img class="img-user" alt="user"  src="assets/images/set.png"></a>
                                <a href=""  class="lg-call"><img class="img-call " alt="user" src="assets/images/Profile.png"><span>{{session_data.name}}</span></a>

                            </div>
                        </div>
                        <div class="res_menu">
                            <div id="hamburger" class="hamburger-icon-container">
                                <span style="font-size:30px;cursor:pointer" onclick="openNav()">&#9776;</span>
                            </div>
                        </div>
                        <div class="hd_menu">
                            <h3>Projects</h3>

                        </div>	

                    </div>

                </div>

            </div>
        </div>
    </header>

    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-7">
                <div class="project-content-wrap">
                    <div class="project-content">

                        <div class="form-container">
                            <form [formGroup]="form" (ngSubmit)="add_project()">
                                <input id='step2' type='checkbox'>
                                <input id='step3' type='checkbox'>

                                <div id="part1" class="form-group">
                                    <div class="panel panel-primary">
                                        <div class="panel-heading">
                                            <h3 class="panel-title">Enter Keywords</h3>
                                            <p class="panel-title">Enter brand, competitor or hashtag to monitor</p>
                                        </div>
                                        <input formControlName="keywords" type="text" id="name" class="form-control" placeholder="Eg:Burger, Petrol" aria-describedby="sizing-addon1">
                                        <span class="error_message" *ngIf="err.keywords">{{err.keywords}}</span>
                                        <div class="phrases-tip"><span>Type comma separated phrases to monitor.</span><div></div></div>
                                        <div class="phrases-tip"><span>Unusual monitoring project? Try our</span><a class="advanced-wizard-link" href="/settings/" target="_self"><span> Advanced Settings</span></a><div></div></div>
                                        <div class="btn-group btn-group-lg" role="group" aria-label="...">
                                            <label for='step2' id="continue-step2" class="continue">
                                                <div (click)="add_keywords()" class="btn btn-default btn-success btn-lg">Next</div>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div id="part2" class="form-group">
                                    <div class="panel panel-primary">
                                        <div class="panel-heading">
                                            <h3 class="panel-title">Track only in selected language</h3>
                                            <p class="panel-title">We will collect mentions ONLY in the language you choose</p>
                                        </div>
                                        <select formControlName="language" class="form-control">
                                            <option value="0">Any Languages</option>
                                            <option value="en">English</option>
                                            <option value="ar">Arabic</option>
                                            <option value="hr">Croatian</option>
                                            <option value="cs">Czech</option>
                                            <option value="da">Danish</option>
                                            <option value="nl">Dutch</option>
                                            <option value="fi">Finnish</option>
                                            <option value="fr">French</option>
                                            <option value="de">German</option>
                                            <option value="hu">Hungarian</option>
                                            <option value="id">Indonesian</option>
                                            <option value="it">Italian</option>
                                            <option value="ko">Korean</option>
                                            <option value="no">Norwegian</option>
                                            <option value="pl">Polish</option>
                                            <option value="pt">Portuguese</option>
                                            <option value="ro">Romanian</option>
                                            <option value="ru">Russian</option>
                                            <option value="sk">Slovak</option>
                                            <option value="es">Spanish</option>
                                            <option value="sv">Swedish</option>
                                            <option value="th">Thai</option>
                                            <option value="tr">Turkish</option>
                                            <option value="vi">Vietnamese</option>
                                        </select>
                                        <div class="btn-group btn-group-lg btn-group-justified" role="group" aria-label="...">

                                            <label for='step2' id="back-step2" class="back">
                                                <div class="btn btn-default btn-primary btn-lg" role="button">Back</div>
                                            </label>

                                            <!--<label for='step3' class="continue">-->
                                                <button class="btn btn-default btn-success btn-lg" role="button">Create a Project</button>
                                            <!--</label>-->

                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-5">

            </div>
        </div>
    </div>
</div>